import * as React from "react";
import { routePath } from "../route-path";
import { Stack, MessageBar, MessageBarType } from "@fluentui/react";
import { LoginStatus } from "../domain/services/service-auth";
import { makeObservable, observable } from "mobx";
import { observer } from "mobx-react";
import ErrorBars from "../ui/molecules/error-bars";
import { LayoutCenter } from "../ui/layouts/layout-centered";
import { store } from "../store";

export type PageLoginProps = {};

@observer
export class PageEmailLoginTokenLogin extends React.Component<PageLoginProps> {
    @observable public accessor status: LoginStatus | undefined;

    constructor(props: PageLoginProps) {
        super(props);
        makeObservable(this);
    }

    async componentDidMount(): Promise<void> {
        // Don't allow users to visit login page if already logged in.
        if (store.serviceAuth.isLoggedIn) {
            store.historyProvider.history.push(routePath.dashboard());
            return;
        }

        const emailLoginToken = store.historyProvider.getQueryParam("token");
        if (typeof emailLoginToken !== "string") {
            return;
        }

        const result = await store.serviceAuth.loginWithEmailLoginToken(emailLoginToken);
        this.status = result.status;
        if (result.status === LoginStatus.SUCCESS) {
            store.historyProvider.history.replace(routePath.settings());
        }
    }

    public render(): JSX.Element {
        let messageBar;
        if (this.status === LoginStatus.INVALID) {
            messageBar = (
                <MessageBar messageBarType={MessageBarType.error}>
                    {store.i18n.t("page.emailLoginTokenLogin.invalid")}
                </MessageBar>
            );
        }
        return (
            <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
                <LayoutCenter>
                    <Stack.Item style={{ maxWidth: "30rem" }}>
                        <ErrorBars />
                        {messageBar}
                    </Stack.Item>
                </LayoutCenter>
            </div>
        );
    }
}
